/**
 * Calculate session duration in seconds from a start timestamp
 * @param loggedInAt - The timestamp when the session started (ISO string or Date)
 * @returns Session duration in seconds, or 0 if no valid start time
 */
export function calculateSessionDuration(
	loggedInAt: string | Date | null | undefined
): number {
	if (!loggedInAt) {
		return 0;
	}

	const startTime = new Date(loggedInAt).getTime();
	const currentTime = new Date().getTime();

	// Return duration in seconds
	return Math.round((currentTime - startTime) / 1000);
}

/**
 * Calculate session duration from user session data
 * @param session - User session object with loggedInAt property
 * @returns Session duration in seconds
 */
export function calculateSessionDurationFromSession(
	session: { loggedInAt?: string | Date } | null | undefined
): number {
	return calculateSessionDuration(session?.loggedInAt);
}
